import moment from 'moment'
import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import Col from 'reactstrap/lib/Col'
import Container from 'reactstrap/lib/Container'
import Row from 'reactstrap/lib/Row'
import { convertDate } from '../../helper'
import { CONSTANT } from '../../helper/AllConastant'
import NoContentFound from '../common/NoContentFound'
 
class RmListing extends Component {
    renderDensity = (cell, row, enumObject, rowIndex) => {
        return (<>
            Density(g/cm<sup>3</sup>)
        </>)
    }

    render() {
        const options = {
            clearSearch: true,
            noDataText: <NoContentFound title={CONSTANT.EMPTY_DATA} />,
          };
        

        return (
            <>    
                <Row className="mt-4">
                    <Col>
                        <BootstrapTable
                            data={this.props.rmDataList}
                            striped={false}
                            bordered={false}
                            hover={false}
                            options={options}
                            search
                            multiColumnSearch={true}
                            // exportCSV={true}
                            ignoreSinglePage
                            // exportCSV={DownloadAccessibility}
                            exportCSV={this.props.isSimulation ? false : true}
                            csvFileName={"RmSpecification.csv"}
                            ref={'table'}
                            pagination>
                            <TableHeaderColumn dataField="RawMaterial" dataAlign="left" dataSort={true}>Material</TableHeaderColumn>
                            <TableHeaderColumn dataField="Density" dataAlign="center" dataSort={true}>{this.renderDensity()}</TableHeaderColumn>
                            <TableHeaderColumn dataField="RMName" dataAlign="center" dataSort={true}>{'Raw Material'}</TableHeaderColumn>
                            <TableHeaderColumn dataField="RMGrade" dataAlign="center" dataSort={true}>{'Grade'}</TableHeaderColumn>
                            <TableHeaderColumn dataField="MaterialId" searchable={false} dataAlign="right" export={false} isKey={true} dataFormat={this.buttonFormatter}>Actions</TableHeaderColumn>
                        </BootstrapTable>
                    </Col>
                </Row>  
            </>
        )
    }
}

export default RmListing;